import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPayments, fetchPaymentsWithFilters } from '../services/api';

// Old endpoint - kept for backward compatibility
export const getPayments = createAsyncThunk('payments/getPayments', async () => {
    const response = await fetchPayments();
    return response.data;
});

// New endpoint with filters and pagination
export const getPaymentsWithFilters = createAsyncThunk(
    'payments/getPaymentsWithFilters',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await fetchPaymentsWithFilters(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch payments');
        }
    }
);

const paymentSlice = createSlice({
    name: 'payments',
    initialState: {
        payments: [],
        status: 'idle',
        error: null,
        pagination: {
            page: 1,
            page_size: 20,
            count: 0,
            total_count: 0,
            total_pages: 0,
        },
        filters: {},
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        resetFilters: (state) => {
            state.filters = {};
        },
    },
    extraReducers: (builder) => {
        builder
            // Old endpoint handlers
            .addCase(getPayments.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getPayments.fulfilled, (state, action) => {
                state.payments = action.payload.data || action.payload;
                state.status = 'succeeded';
            })
            .addCase(getPayments.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // New endpoint handlers
            .addCase(getPaymentsWithFilters.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getPaymentsWithFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === 1) {
                    state.payments = action.payload.data || [];
                    if (action.payload.pagination) {
                        state.pagination = {
                            page: action.payload.pagination.page || 1,
                            page_size: action.payload.pagination.page_size || 20,
                            count: action.payload.pagination.count || 0,
                            total_count: action.payload.pagination.total_count || 0,
                            total_pages: action.payload.pagination.total_pages || 0,
                        };
                    }
                } else {
                    state.payments = [];
                    state.error = 'Failed to fetch payments';
                }
            })
            .addCase(getPaymentsWithFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const { setFilters, resetFilters } = paymentSlice.actions;
export default paymentSlice.reducer;